module.exports = __webpack_public_path__ + "static/media/NE.3ec915c9.svg";